import React from "react";
import "../style/Assess.css";

const AssessTop = () => {
  return (
    <div className="Assess">
      <div className="assess-bg assess-top"></div>
      <div className="assess-inside top">
        <h1>FEATURE-PROOF YOUR ORGANIZATION</h1>
        <h5>
          Find out how to unlock progress in your business. Understand your
          current state, identify <br />
          opportunity areas and prepare to take charge of your organization's
          future.
        </h5>
        <button className="assessBtn yellowBtn">
          <a
            href="https://brainsterquiz.typeform.com/to/kC2I9E"
            target="_blank"
            rel="noopener noreferrer"
          >
            Take the assessment
          </a>
        </button>
      </div>
    </div>
  );
};

export default AssessTop;
